<template>
  <!-- 订单管理列表 -->
  <div class="page">
    <div class="search">
      <div class="title">订单历史</div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="项目名称：">
          <el-input
            v-model="formInline.projectName"
            placeholder="项目名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单号：">
          <el-input
            v-model="formInline.orderNum"
            placeholder="订单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="招标人：">
          <el-input
            v-model="formInline.profitsPerson"
            placeholder="招标人"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请日期：">
          <el-date-picker
            v-model="formInline.applyDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="所属地区:">
          <el-select style="width:200px;" v-model="formInline.payment" placeholder="请选择">
            <el-option label="已支付" value="0"></el-option>
            <el-option label="待支付" value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="订单状态：">
          <el-select
            style="width: 200px"
            v-model="formInline.orderStatus"
            placeholder="请选择"
          >
            <el-option label="待支付" value="2"></el-option>
            <el-option label="待出函" value="4"></el-option>
            <el-option label="已出函" value="5"></el-option>
            <el-option label="已驳回" value="9"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标段名称：">
          <el-input
            v-model="formInline.bidName"
            placeholder="标段名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请类型：">
          <el-select
            style="width: 200px"
            v-model="formInline.orderType"
            placeholder="请选择"
          >
            <el-option label="自助申请" value="2"></el-option>
            <el-option label="项目列表" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务类型：">
          <el-select
            style="width: 200px"
            v-model="formInline.businessType"
            placeholder="请选择"
          >
            <el-option label="投标保函" value="1"></el-option>
            <el-option label="履约保函" value="2"></el-option>
            <el-option label="预付款保函" value="3"></el-option>
            <el-option label="农民工工资保函" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="保险公司：">
          <el-select
            style="width: 200px"
            v-model="formInline.insuranceCompanyName"
            placeholder="请选择"
          >
            <el-option label="安诚财险" value="1"></el-option>
            <el-option label="大家保险" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" size="medium" @click="query"
            >查询</el-button
          >
          <el-button type="info" size="medium" @click="Reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        stripe
        :header-cell-style="{ background: '#F6F6FC', color: '#738DA2' }"
        :cell-style="{ color: '#738DA2' }"
        :height="tableHeight"
        style="width: 100%"
      >
        <el-table-column label="序号" align="center" type="index" width="50">
        </el-table-column>
        <el-table-column prop="orderNum" label="订单号" align="center">
        </el-table-column>
        <el-table-column prop="businessType" label="业务类型" align="center">
        <template slot-scope="scope">
          <span v-show="scope.row.businessType == '1'">投标保函</span>
          <span v-show="scope.row.businessType == '2'">履约保函</span>
          <span v-show="scope.row.businessType == '3'">预付款保函</span>
          <span v-show="scope.row.businessType == '4'">农民工工资保函</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderNum" label="出函保险公司" align="center" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.insuranceCompanyName=='1'">安诚财险</span>
            <span v-if="scope.row.insuranceCompanyName=='2'">大家保险</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
          width="240"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.projectName?scope.row.projectName:'------' }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="bidName"
          label="标段名称"
          align="center"
          width="240"
        >
          <template slot-scope="scope">
            <p >{{ scope.row.bidName?scope.row.bidName:'------' }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="profitsPerson" label="招标人" align="center">
          <template slot-scope="scope">
            <p >{{ scope.row.profitsPerson?scope.row.profitsPerson:'------' }}</p>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="payment" align="center" label="所属地区">
        <template slot-scope="scope">
          <p v-show="scope.row.payment == '0'">已支付</p>
          <p v-show="scope.row.payment == '1'">待支付</p>
        </template>
      </el-table-column> -->
        <!-- <el-table-column prop="date" label="申请类型" align="center">
      </el-table-column> -->
        <el-table-column align="center" label="申请类型">
          <template slot-scope="scope">
            <p v-show="scope.row.orderType == '1'">线上保函</p>
            <p v-show="scope.row.orderType == '2'">自助申请</p>
          </template>
        </el-table-column>
        <el-table-column prop="applyDate" label="申请时间" align="center">
        </el-table-column>
        <el-table-column prop="orderFee" align="center" label="订单金额">
          <template slot-scope="scope">
            <p >{{ scope.row.orderFee?scope.row.orderFee:'------' }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="guarantee" align="center" label="订单状态">
          <template slot-scope="scope">
            <el-tag type="danger" v-show="scope.row.orderStatus == 2"
              >待支付</el-tag
            >
            <el-tag v-show="scope.row.orderStatus == 3">待出函</el-tag>
            <el-tag v-show="scope.row.orderStatus == 4">待出函</el-tag>
            <el-tag v-show="scope.row.orderStatus == 5" type="success"
              >已出函</el-tag
            >
            <el-tag v-show="scope.row.orderStatus == 9" type="warning">已驳回</el-tag>
            <p v-show="scope.row.orderStatus == 15">------</p>
          </template>
        </el-table-column>
        <el-table-column prop="remark" align="center" label="备注" width="180">
          <template slot-scope="scope">
            <p >{{ scope.row.remark?scope.row.remark:'------' }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              v-if="scope.row.orderStatus == 2"
              @click="pay(scope.row)"
              >支付</el-button
            >
            <el-button
              size="mini"
              type="primary"
              v-if="scope.row.orderStatus == 9"
              @click="agin"
              >重新申请</el-button
            >
            <el-button
              size="mini"
              style="background: #00dafe; border: 0; color: #fff"
              v-show="scope.row.orderStatus == '5'"
              @click="withdrawal(scope.row)"
              >退保</el-button
            >
            <el-button
              size="mini"
              type="primary"
              v-if="scope.row.orderStatus == '5'"
              @click="download(scope.row)"
              >保函下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="this.formInline.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="this.formInline.pageNum"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.total"
      ></el-pagination>
    </div>
      <retreat
        :dialogVisible.sync="dialogVisible"
        :formData="formData"
        @closePop="closePop"
      ></retreat>
      <prompt :successVisible.sync="successVisible" :popData="popData">
      </prompt>
    <!-- </div> -->
  </div>
</template>

<script type="text/ecmascript-6">
import { getOrderList, getGuaranteeUrl,getDaGuaranteeUrl } from "../apis/project/index"
import Prompt from './components/prompt.vue'
import Retreat from './components/retreat.vue'
export default {
  data() {
    return {
      tableHeight:null,
      total:null,
      formInline: {
        page:1,
        pageNum:10,
        userId:null,
        orderNum:null,
        projectName:null,
        bidName:null,
        profitsPerson:null,
        createDate:null,
        applyDate:null,
        orderStatus:null,
        orderType: null,
        insuranceCompanyName:null,
      },
      tableData: [
      ],
      dialogVisible: false,//弹窗
      formData: {},//传值
      successVisible: false,//提交成功
      popData: {
        img: require('../assets/success.png'),
        bule: '您已成功提交退保申请！',
        grey: '您可以再退保管理中查看退保进度',
      }
    }
  },
  created(){
    this.formInline.userId=window.sessionStorage.getItem("userId")
    this.getList();
  },
  methods:{
    pay(e){
      window.sessionStorage.setItem("orderId",e.orderId);
      window.sessionStorage.setItem("comCode",e.guarantorId);
      window.sessionStorage.setItem("orderFee",e.orderFee);
      window.sessionStorage.setItem("type", e.orderType);
      window.sessionStorage.setItem("insuranceCompanyName", e.insuranceCompanyName);
      this.$router.push({ path: '/selfHelp',query:e });
    },
    query(){
      this.formInline.page=1;
      this.getList();
    },
    getList(){
      getOrderList(this.formInline).then((res)=>{
        console.log("REsresres",res);
        this.tableData=res.data.data.data;
        this.total=res.data.data.total;
      })
    },
    heightTab(){
      this.tableHeight=document.documentElement.clientHeight - 470;
    },
    Reset(){
      this.formInline.page=1;
      this.formInline.orderNum=null;
      this.formInline.projectName=null;
      this.formInline.bidName=null;
      this.formInline.profitsPerson=null;
      this.formInline.createDate=null;
      this.formInline.applyDate=null;
      this.formInline.orderType=null;
      this.formInline.orderStatus=null;
      this.formInline.businessType = null;
      this.formInline.insuranceCompanyName = null;
      this.getList();
    },
    download(e) {
      if (e.insuranceCompanyName == '1') {
        getGuaranteeUrl(e.orderId).then((res)=>{
          // console.log("res",res);
          window.open(res.data.data.guaranteeUrl[0])
        })
      }
      else {
        getDaGuaranteeUrl(e.orderNum).then((res)=>{
          // console.log("res",res);
          window.open(res.data.data)

        })
      }

      // this.$router.push('/guarantee')
      // window.open("http://39.98.152.102:8989/hetinterface/hetInterfaceController.do?getPdfFile&filePath=/usr/local/upload/eic/01771.pdf")
    },
    withdrawal(row){
      // this.$router.push({ path: '/retreat', query: row })
      this.dialogVisible = true
      this.formData = row
      // this.$confirm('您是否确定撤销该笔投标保函?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.$message({
      //       type: 'success',
      //       message: '撤销成功!'
      //     });
      //   }).catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '已取消撤销'
      //     });
      //   });
    },
    handleSizeChange(val) {
      this.formInline.pageNum=val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formInline.page=val;
      this.getList();
    },
    closePop(e) {
      this.successVisible = e
      this.getList();
    },
    agin() { 
      this.$router.push('/selfHelp')
    }
  },
  mounted(){
    this.heightTab();
    window.addEventListener("resize",this.heightTab,false);
    this.total=this.tableData.length
  },
  components: {
    Retreat,
    Prompt

  }
}
</script>

<style scoped>
.page {
  height: 100%;
  font-size: 16PX;
}
::v-deep .el-form-item__label {
  font-weight: bold;
}
</style>
